import {
  AuthApi,
  AuthAdapter,
  LocalStorage,
  AuthApiSessionManager,
} from '@wheely/web-auth-lib/legacy';

import { ENV } from '@/env';
import { getApiUrl } from '@/shared/utils/getApiUrl';

import { LEGACY_SESSION_STORAGE_KEY } from '../mode';

const storageKey = LEGACY_SESSION_STORAGE_KEY;
const syncronizerStorageKey = `${LEGACY_SESSION_STORAGE_KEY}-sync`;

const storage = new LocalStorage();

const adapter = new AuthAdapter({ apiHost: getApiUrl(), appId: ENV.APP_ID || '' });

const sessionManager = new AuthApiSessionManager({
  storage,
  tabSyncronizerConfig: {
    storageKey: syncronizerStorageKey,
  },
  adapter,
  sessionStorageKey: storageKey,
});

const authAPI = new AuthApi({ sessionManager });

export { authAPI, sessionManager };
